export default "__VITE_ASSET__BqfbDcHV__"